













import {
  computed,
  defineComponent,
  inject,
  onBeforeUnmount,
  onMounted,
  PropType,
  Ref,
  ref,
} from "@vue/composition-api";
import {
  ContentPriceSubjectTypeEnum,
  InputContentPriceUpdate,
} from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { InputContentSubscriptionLevelUpdate } from "@scrile/api-provider/dist/api/ContentSubscriptionLevelProvider";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import PriceSetupView from "../PriceSetupView";

export default defineComponent({
  name: "PriceSetupController",
  components: { PriceSetupView },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props) {
    const userId = inject<Ref<string>>("contentFeedUserId", ref(""));
    const show = ref(false);
    const priceList = ref<SubscriptionLevel[]>([]);
    const packageList = ref<PaymentPackage[]>([]);
    const pricePackageId = ref("0");
    const subscriptionlevelId = ref("0");
    const hideSubscriptionLevelField = computed(
      () =>
        props.postData.type === ContentFeedTypeEnum.CLIP || props.postData.type === ContentFeedTypeEnum.PHOTO_GALLERY
    );
    const sendEvent = () => {
      emitter.emit(EVENTS.CONTENT_FEED_PRICE_CHANGED, {
        recurringLevel: priceList.value.find(i => i.id === subscriptionlevelId.value) || null,
        oneTimePackage: packageList.value.find(i => i.id === pricePackageId.value) || null,
      });
    };

    const setShow = (status = true) => {
      show.value = status;
    };

    const onSave = ({ packageId, levelId }: { packageId: string; levelId: string }, cb: Function) => {
      let priceUpdate: InputContentPriceUpdate = {
        packageId,
        subject: {
          subjectType: ContentPriceSubjectTypeEnum.CONTENT_SET,
          subjectId: props.postData.id,
        },
      };
      let levelUpdate: InputContentSubscriptionLevelUpdate = {
        levelId,
        subject: {
          subjectType: ContentPriceSubjectTypeEnum.CONTENT_SET,
          subjectId: props.postData.id,
        },
      };
      Promise.all([
        providers.ContentPriceProvider.update({ data: priceUpdate }).then(r => (pricePackageId.value = r.packageId)),
        providers.ContentSubscriptionLevelProvider.update({ data: levelUpdate }).then(
          r => (subscriptionlevelId.value = r.levelId)
        ),
      ]).finally(() => {
        cb();
        setShow(false);
        sendEvent();
      });
    };

    const getData = async () => {
      try {
        await Promise.all([
          providers.ContentPriceProvider.search({
            subjects: [
              {
                subjectType: ContentPriceSubjectTypeEnum.CONTENT_SET,
                subjectId: props.postData.id,
              },
            ],
          }).then(
            r =>
              (pricePackageId.value = (
                r.find(i => i.subject.subjectId === props.postData.id) || { packageId: "0" }
              ).packageId)
          ),
          providers.ContentSubscriptionLevelProvider.search({
            subjects: [
              {
                subjectType: ContentPriceSubjectTypeEnum.CONTENT_SET,
                subjectId: props.postData.id,
              },
            ],
          }).then(
            r =>
              (subscriptionlevelId.value = (
                r.find(i => i.subject.subjectId === props.postData.id) || { levelId: "0" }
              ).levelId)
          ),
          providers.SubscriptionLevelProvider.find({ userIds: [userId.value] }).then(r => (priceList.value = r)),
          providers.PaymentPackageProvider.findAll({ type: [PaymentPackageEnum.FILESET] }).then(
            r => (packageList.value = r)
          ),
        ]);
      } finally {
        sendEvent();
      }
    };

    getData();

    onMounted(() => {
      emitter.on<any>(EVENTS.CONTENT_FEED_PRICE_SHOW, setShow);
    });

    onBeforeUnmount(() => {
      emitter.off<any>(EVENTS.CONTENT_FEED_PRICE_SHOW, setShow);
    });

    return {
      packageList,
      priceList,
      pricePackageId,
      subscriptionlevelId,
      show,
      hideSubscriptionLevelField,
      onSave,
      setShow,
    };
  },
});
